'use client';

import { c as _c } from "react/compiler-runtime";
import { Typography, Button, Card, CardContent, Stack } from '@mui/material';
import Image from 'next/image';
import { signIn } from 'next-auth/react';
import { Illustrations } from '@/components/Illustrations';
import { themeConfig } from '@/configs/themeConfig';
const LoginV1 = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Stack sx={{
      gap: "12px"
    }}><Typography variant="h2">{`Welcome to ${themeConfig.templateName}!👋🏻`}</Typography><Typography variant="body1" className="mbs-1">Please sign-in to your account and start the adventure</Typography></Stack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Card className="flex flex-col sm:is-[450px]"><CardContent className="p-12!"><div className="flex flex-col gap-5">{t0}<form noValidate={true} autoComplete="off" onSubmit={_temp} className="flex flex-col gap-5"><div className="flex justify-center items-center gap-2"><Button color="secondary" className="self-center text-(--mui-palette-text-primary)" startIcon={<Image src="/statics/images/logos/google.png" alt="Google" width={22} height={22} />} sx={{
                "& .MuiButton-startIcon": {
                  marginInlineEnd: 3
                }
              }} onClick={_temp2}>Sign in with Google</Button></div></form></div></CardContent></Card>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col items-center min-bs-[100dvh] relative p-6">{t1}<Illustrations maskImg={{
        src: "/statics/images/pages/auth-v2-mask-light.png"
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export { LoginV1 };
function _temp(e) {
  return e.preventDefault();
}
function _temp2() {
  return void signIn("google");
}